module.exports = __webpack_public_path__ + "static/alpha_logo_full-f21ea6dccde5ecae1579dc33f2ac9793.png";